import compose from 'compose-function';
import withAntd from './with-antd';
import withRouter from './with-router';
import withRedux from './with-redux';

/**
 * @hoc Инициализирующая логика приложения
 * @remark Содержит:
 * - логику инициализации antd (withAntd)
 * - логику подключения к API (withApollo)
 * - логику инициализации роутера (withRouter)
 */
export const withHocs = compose(withRedux, withAntd, withRouter);
